import Card from './Card';
import { StyledCard, NewItemCard } from './Card.styles';
export { StyledCard, NewItemCard };
export default Card;
